<template>
  <div>
    <FilterGroup
      v-for="group in filterGroups"
      :key="group.value"
      :group="group"
      :is-collapsed="isGroupCollapsed(group.value)"
      @select="onFilterGroupSelect"
    >
      <template #filter="{ id }">
        <FacetFilters
          :group-id="id"
          :facets="group.facets"
          @change="onChangeCategory"
        />
      </template>
    </FilterGroup>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import FacetFilters from './FacetFilters.vue';
import FilterGroup from './FilterGroup.vue';
import { mutation, action } from './store';

const { mapGetters } = createNamespacedHelpers('search');

export default {
  name: 'SearchFilters',

  components: {
    FacetFilters,
    FilterGroup,
  },

  data() {
    return {
      openGroupId: 0,
    };
  },

  computed: {
    ...mapGetters(['filterGroups']),
  },

  watch: {
    filterGroups: {
      immediate: true,
      handler(filterGroups) {
        if (this.openGroupId) {
          return;
        }

        this.openGroupId = filterGroups.length > 0 ? filterGroups[0].value : 0;
      },
    },
  },

  methods: {
    isGroupCollapsed(groupId) {
      return this.openGroupId !== groupId;
    },

    onFilterGroupSelect({ isCollapsed, groupId }) {
      this.openGroupId = isCollapsed ? groupId : 0;
    },

    async onChangeCategory(event) {
      this.$store.commit(mutation('TOGGLE_SELECTED_FILTER'), event);

      await this.$store.dispatch(action('LOAD_SEARCH_RESULTS'));
    },
  },
};
</script>
